<template>
    <div class="page page-view">
        <div class="bg">
            <div class="cloud-01">
                <img src="../assets/img/cloud.png" alt="">
            </div>
            <div class="cloud-02">
                <img src="../assets/img/cloud.png" alt="">
            </div>
        </div>
        <div class="page-view-item page-view-01" :class="[currentIndex == 0 && 'show', currentIndex == 1 && 'hide']">
            <div class="page-inner">
                <ul>
                    <li>
                        <p><span>2016</span>年<span>5</span>月<span>4</span>日</p>
                        <p>封面新闻V1.0测试版上线试运行</p>
                    </li>
                    <li>
                        <p><span>2016</span>年<span>6</span>月<span>14</span>日</p>
                        <p>封面新闻获一类互联网新闻信息服务资质</p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="page-view-item page-view-02" :class="[currentIndex == 1 && 'show', currentIndex == 2 && 'hide']">
            <div class="page-inner">
                <ul>
                    <li>
                        <p><span>2017</span>年<span>9</span>月<span>16</span>日</p>
                        <p>封面新闻人工智能与未来媒体实验室成立</p>
                    </li>
                    <li>
                        <p><span>2017</span>年<span>11</span>月<span>10</span>日</p>
                        <p>封面智库入选2017年度中国核心智库</p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="page-view-item page-view-03" :class="[currentIndex == 2 && 'show', currentIndex == 3 && 'hide']">
            <div class="page-inner">
                <ul>
                    <li>
                        <p><span>2018</span>年<span>5</span>月<span>4</span>日</p>
                        <p>封面传媒与四川文化产业股权投资基金宣布共同推进封面传媒资本化进程</p>
                    </li>
                    <li>
                        <p><span>2018</span>年<span>11</span>月<span>16</span>日</p>
                        <p>封面主办第十三届传媒年会</p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="page-view-item page-view-04" :class="[currentIndex == 3 && 'show', currentIndex == 4 && 'hide']">
            <div class="page-inner">
                <ul>
                    <li>
                        <p><span>2019</span>年<span>9</span>月<span>17</span>日</p>
                        <p>2019第十届C21论坛成功举办</p>
                    </li>
                    <li>
                        <p><span>2019</span>年<span>8</span>月<span>13</span>日</p>
                        <p>封面新闻重庆中心正式成立</p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="page-view-item page-view-05" :class="[currentIndex == 4 && 'show']">
            <div class="page-inner">
                <ul>
                    <li>
                        <p><span>2020</span>年<span>4</span>月<span>28</span>日</p>
                        <p>封面新闻V6.0上线，开启封面智媒云新时代</p>
                    </li>
                    <li>
                        <p><span>2020</span>年<span>9</span>月<span>21</span>日</p>
                        <p>第八届中国（绵阳）科技城国际科技博览会</p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="nav">
            <span v-for="(item, index) in years" :class="[index <= currentIndex && 'show']">{{item}}</span>
        </div>
        <div class="btn" @click="goData">
            <span>回顾我的封面2020</span>
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'

import Moment from 'moment'

import COVERAPP from '@/utils/COVERAPP'

@Options({
    data () {
        return {
            currentIndex: 0,
            years: [2016, 2017, 2018, 2019, 2020],
            timeId: null,
            isGeting: false
        }
    },
    computed: {
        ...mapState(['aid', 'userInfo', 'shareData', 'activityData'])
    },
    beforeUnmount () {
        clearInterval(this.timeId)
        this.currentIndex = 0
    },
    mounted () {
        this.$common.track(this.aid, 'load', '新闻2020年内的重大事件')
        this.activityData && this.$common.pageLoaded()
        this.shareData.title && this.$common.onshare(this.shareData, this.aid)
        this.timeId = setInterval(() => {
            this.changeData()
        }, 2000)
    },
    methods: {
        ...mapMutations(['SET_USERINFO', 'SET_YEARDATA', 'SET_DIALOGDATA']),
        changeData (): void {
            const items = document.querySelectorAll('.page-view .page-view-item') as NodeListOf<HTMLElement>
            if (this.currentIndex === items.length - 1) {
                clearInterval(this.timeId)
                const btn = document.querySelector('.page-view .btn') as HTMLElement
                btn.className = `${btn.className} show`
                return
            }
            this.currentIndex++
        },
        goData () {
            const _this = this
            this.$common.track(this.aid, 'click', '我的封面2020') 
            if (!COVERAPP.Attribute.isApp()) {
                this.SET_DIALOGDATA({
                    text: '参加该活动需在封面新闻APP中进行',
                    btns: [
                        {
                            text: '确定',
                            className : 'download-btn',
                            data: this.activityData.openApp
                        }
                    ]
                })
                return
            }
            if (!this.userInfo.token) {
                COVERAPP.Method.OpenLogin({
                    callback (ret: any) {
                        let userinfo = typeof ret == "string".toLowerCase() ? JSON.parse(ret) : ret
                        if (!_this.$common.isEmpty(userinfo.user_id)) {
                            if (userinfo.mobile) {
                                setTimeout(() => {
                                    _this.$common.getUser((res: any) => {
                                        _this.SET_USERINFO(res)
                                        _this.getData()
                                    }) 
                                }, 200)
                            } else {
                               _this.bindMobile()  
                            }       																													
                        }
                    }
                })
                return
            }
            if(!this.userInfo.mobile) {
                this.bindMobile()              
                return
            }
            this.getData()
        },
        bindMobile () {
            const _this = this
            COVERAPP.Method.bindMobile({
                callback(res: any) {
                    const result = typeof res != 'string' ? JSON.stringify(res) : res
                    if (result.indexOf('success') > -1) {
                        _this.$common.getUser((res: any) => {
                            _this.SET_USERINFO(res)
                            _this.getData()
                        })
                    }                    
                }
            })
        },
        getData () {
            if (this.isGeting) return
            this.isGeting = true
            this.$request('/year-report-2020', {
                aid: this.aid,
                userinfo: this.userInfo
            }, 'post').then((data: any) => {
                if (data && data.import_time) {
                    this.formatData(data)
                    this.$router.push({
                        path: '/data'
                    })
                } else {
                    this.noData()
                }
                this.isGeting = false
            }).catch((res: any) =>  {
                if (!res || !res.errno || (res.errno && res.errno != 1250 && res.errno != 1010 && res.errno != 1200)) {
                    this.$common.toast('加载失败，请重试！')
                } else if (res && res.errno == 1200) {
                    this.noData()
                }
                this.isGeting = false
            })
        },
        formatData (data: any) {
            let newData = JSON.parse(JSON.stringify(data))
            const times = ['import_time', 'first_news_view_date', 'first_discuss_date', 'first_share_date', 'first_live_view_date', 'first_dynamic_create_date', 'last_arrive_date', 'use_time_early', 'use_time_lately']
            for (let time of times) {
                newData[time] && (newData[time] = Moment(data[time]).utc().format('YYYY-M-D-H-m').split('-'))
            }
            if (newData.channel_label) {
                newData.channel_label = newData.channel_label.split(',')
            }
            this.SET_YEARDATA(newData)
            sessionStorage.setItem('YEARDATA', JSON.stringify(newData))
        },
        noData () {
            this.SET_DIALOGDATA({
                text: '错过了封面2020的精彩<br>但仍有一份惊喜礼物送给你<br>欢迎你加入封面，2021一起加油呀',
                btns: [
                    {
                        text: '新人惊喜礼',
                        className: 'getHb-btn'
                    }
                ]
            })
        }
    }
})
export default class FootPrint extends Vue {}
</script>

<style lang="scss">
.page-view {
    font-size: 0;
    height: 100%;
    background: #fcfcfc url('../assets/img/view_bg.jpg') no-repeat center bottom;
    background-size: 100% auto;
    overflow-x: hidden;
    position: relative;
    .page-view-item {
        height: 100%;  
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        display: none;
        &.show {
            display: block;
            animation: fadeIn 1.5s forwards;
        }
        &.hide {
            display: block;
            animation: fadeOut 1.5s forwards;
            .page-inner {
                animation: backOutLeft 1s forwards;
            }
        }
    }
    .page-inner {
        padding: 2.5rem 1.018519rem;
        ul {
            li {
                padding-left: .224074rem;
                position: relative;
                animation: backInLeft 1s forwards;
                margin-bottom: .092593rem;
                &:nth-of-type(2) {
                    animation-duration: 1.5s;
                }
                &:nth-of-type(3) {
                    animation-duration: 2s;
                }
                
                p {
                    font-size: .37037rem;
                    color: #000;
                    line-height: 2;
                    &:first-child {
                        position: relative;
                        &::before {
                            content: '';
                            width: .203704rem;
                            height: .203704rem;
                            background-color: #ff3437;
                            border-radius: 50%;
                            transform: translateY(-50%) scale(.5);
                            transform-origin: left top;
                            position: absolute;
                            left: -.224074rem;
                            top: 50%;
                        }
                    }
                    span {
                        color: #ff3437;
                    }
                }
            }
        }
    }
    .bg {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        font-size: 0;
        .cloud-01 {
            position: absolute;
            width: .444444rem;
            top: 1.425926rem;
            left: 5.222222rem;
            transform: translateY(-50%);
            animation: floatupdown 2s alternate infinite;
        }
        .cloud-02 {
            position: absolute;
            width: .62963rem;
            top: 3.537037rem;
            right: 2.185185rem;
            transform: translateY(50%);
            animation: floatupdown 3s alternate infinite;
        }
    }
    .nav {
        position: absolute;
        width: 100%;
        height: 108.704vw;
        left: 0;
        bottom: 0;
        span {
            position: absolute;
            top: 45vw;
            left: 3.426vw;
            font-size: 6.111vw;
            font-weight: bold;
            color: #fff;
            height: 9.63vw;
            width: 20vw;
            border: 1.111vw solid #fff;
            align-items: center;
            justify-content: center;
            background-color: #ec473c;
            border-radius: 3.704vw;
            transform-origin: left top;
            transform: scale(.5);
            opacity: 0;
            transition: opacity .5s;
            &.show {
                opacity: 1;
                display: flex;
                animation: fadeShadow 2s alternate infinite;
            }
            &:nth-of-type(2) {
                left: 18.889vw;
                top: 14.963vw;
            }
            &:nth-of-type(3) {
                left: 40.185vw;
                top: 38.148vw;
            }
            &:nth-of-type(4) {
                left: 54.074vw;
                top: 21.852vw;
            }
            &:nth-of-type(5) {
                left: 78.148vw;
                top: 45vw;
            }
        }
    }
    .btn {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 2.037037rem;
        height: .888889rem;
        display: none;
        justify-content: center;
        background: linear-gradient(#fd4144, #d7151b);
        border-radius: .444444rem;
        padding: 0 .509259rem 0 .555556rem;
        align-items: center;
        cursor: pointer;
        animation: btnbeat 1s infinite;
        overflow: hidden;
        text-decoration: none;
        &.show {
            display: flex;
        }
        &::before {
            content: '';
            position: absolute;
            left: .12963rem;
            top: .083333rem;
            width: .694444rem;
            height: .277778rem;
            background: url('../assets/img/btn_light.png') no-repeat left top;
            background-size: 100% 100%;
        }
        span {
            font-size: .407407rem;
            color: #fff;
            line-height: 1.4;
            letter-spacing: .046296rem;
        }
    }
}

@keyframes fadeShadow {
    100% {
        box-shadow: 0 0 3.704vw 1.389vw #fff;
        text-shadow: 0 0 1.852vw #fff;
    }
}

@keyframes btnbeat {
    0% {
        transform: translateX(-50%) scale(1)
    }
    14% {
        transform: translateX(-50%) scale(1.2)
    }
    28% {
        transform: translateX(-50%) scale(1)
    }
    42% {
        transform: translateX(-50%) scale(1.2)
    }
    70% {
        transform: translateX(-50%) scale(1)
    }
}
</style>